/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import { breakpointsMap } from '@oneaudi/unified-web-common';
import { ProgressIndicator } from '@oneaudi/unified-web-components';
import { useGoogleConsent } from '@oneaudi/two-click';
import Map from '../Map/Map';
import Sidebar from '../Sidebar/Sidebar';
import LocationErrorMessage from '../LocationErrorDisplay/LocationErrorMessage';
import mapContext from '../../../contexts/map-context';
import { ONE_HEADER_HEIGHT } from '../../common/global.style.constants';
import MyAudiModal from '../MyAudiModal/MyAudiModal';
import type { UnifiedTheme } from '../../../FeatureApp';

interface DesktopMapProps {
  isLoaded?: boolean;
}

interface DesktopLayoutProps {
  revokeConsent?: () => void;
}

export default function DesktopLayout(props: DesktopLayoutProps) {
  const {
    showLocationError,
    isGoogleMapsApiLoaded,
    twoClickConsentRequired,
    showModal,
    ctaBarButtonConfig,
  } = mapContext.useMapState();
  const { revokeConsent } = props;
  const consent = useGoogleConsent(true);

  return (
    <>
      {!isGoogleMapsApiLoaded && (
        <LoaderContainer>
          <ProgressIndicator
            type="infinite"
            variant="spinner"
            colorScheme="colored"
            data-test-id="desktop-layout-component"
          />
        </LoaderContainer>
      )}
      {showModal && <MyAudiModal ctaBarButtonConfig={ctaBarButtonConfig} />}

      <DesktopContainer isLoaded={isGoogleMapsApiLoaded} data-testid="desktop-container">
        <Sidebar revokeConsent={revokeConsent} />
        <MapContainer id="desktopMap">
          {!twoClickConsentRequired || consent ? <Map /> : null}
        </MapContainer>
        {showLocationError && <LocationErrorMessage data-test-id="location-error-display" />}
      </DesktopContainer>
    </>
  );
}

const DesktopContainer = styled.div<DesktopMapProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: calc(100vh - ${ONE_HEADER_HEIGHT});
  margin: 0 auto;
  max-height: 1080px;
  max-width: ${breakpointsMap.xxl};
  min-height: 500px;
  overflow: hidden;
  position: relative;
  visibility: ${(props) => (props.isLoaded ? 'visible' : 'hidden')};
  width: 100%;
  z-index: 0;
`;

const LoaderContainer = styled.div`
  align-items: center;
  background-color: ${(props: UnifiedTheme) =>
    props.theme.sys.color.canvas[200] || props.theme.sys.color.canvas.default};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 1;
`;

const MapContainer = styled.div`
  position: relative;
  flex-grow: 1;
`;
